"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _commonUIColors = require("../../utils/commonUIColors");

// @ts-ignore no module typings
var schema = (0, _reactDesc.describe)({
  displayName: 'Message'
});
schema.propTypes = {
  color: _reactDesc.PropTypes.oneOf(_commonUIColors.commonUIColorKeys).description('When size is small defines the icon color, otherwise the circle fill color. ' + 'Will override the default color associated with any specified `intent`.').format('string'),
  icon: _reactDesc.PropTypes.element.description('Which `iconix` icon to display; Will override the default icon associated with any specified `intent`.'),
  size: _reactDesc.PropTypes.oneOf(['small', 'medium', 'large', 'extraLarge']).description('Defines the variation of size that the content should have').defaultValue('small'),
  variant: _reactDesc.PropTypes.oneOf(['horizontal', 'vertical']).description('Only applies when `size` is `medium`. Used to define if the icon and text ' + 'should be arranged vertically or horizontally, the arragement is always ' + 'horizontal for small messages and vertical for large and extra large messages').defaultValue('horizontal'),
  title: _reactDesc.PropTypes.string.description('Text to show as title, this does not apply when `size` is `small`'),
  intent: _reactDesc.PropTypes.oneOf(['information', 'success', 'warning', 'danger', 'help']).description('Shortcuts to the most common combinations of icon and color.').defaultValue('information')
};
var _default = schema;
exports.default = _default;